import React from "react";
import styles from "./style.module.css";

import { Button } from "aible";

import { VIEW_TYPE } from "containers/View/reducer";

import AibleLogo from "images/Aible_Logo/Aible_Logo.png";
import pathFind from "images/tileIcons/walkthrough-dark.svg";
import Tour from "reactour";

export default class SenseTour extends React.Component {
  constructor(props) {
    super(props);

    this.state = { isDisableNavigation: false };
  }

  // Hack so enter continues instead of closing tour
  hiddenUpdateStep(timeout) {
    const { step, updateStep } = this.props;

    document.getElementById("continueButton") &&
      document.getElementById("continueButton").children[0] &&
      document.getElementById("continueButton").children[0].click();

    return updateStep(step + 1);
  }

  render() {
    const { isOpen, step, dataset, updateIsOpenSense, updateStep, updateType } = this.props;

    const { isDisableNavigation } = this.state;

    const handleClickSection = (section) => {
      const clickableDiv = document.getElementById(section);

      if (clickableDiv) {
        clickableDiv.click();
      }
    };

    const setShowHighlight = (isShowHighlight) => {
      this.setState({ isDisableNavigation: !isShowHighlight });

      const highlightDiv = document.getElementById("mask-main");

      if (highlightDiv) {
        highlightDiv.style.display = isShowHighlight === true ? "block" : "none";
      }
    };

    const CLOSE_DELAY = 300;
    const OPEN_DELAY = 600;

    const steps =
      dataset?.id === undefined
        ? [
            {
              selector: "#mainApp",
              content: ({ goTo, inDOM }) => (
                <div className={styles.tContent}>
                  <div className={styles.aibleLogo}>
                    <img
                      src={AibleLogo}
                      style={{
                        width: "100%",
                        height: "auto"
                      }}
                    />
                  </div>
                  <div className={styles.tHeader + " " + styles.centered}>{"Welcome to Aible Sense!"}</div>
                  <div>
                    {"Aible Sense is the zero upfront effort and low-cost way to evaluate data. " +
                      "Helping you quickly identify what data is ready for analysis and AI creation."}
                  </div>
                  <div className={styles.logoWrapper}>
                    <img
                      src={pathFind}
                      style={{
                        marginTop: "-2px",
                        width: "100%",
                        height: "auto"
                      }}
                    />
                  </div>

                  <div className={styles.tFooter}>
                    <Button
                      type="primary"
                      onClick={() => {
                        updateStep(step + 1);
                        setShowHighlight(true);
                      }}
                    >
                      {"Show Me Around"}
                    </Button>
                  </div>
                </div>
              ),
              style: {
                maxWidth: "500px",
                minWidth: "500px"
              }
            },
            {
              selector: "#senseDataImport",
              content: () => (
                <div className={styles.tContent}>
                  <div className={styles.tHeader}>{"Connecting To Your Data"}</div>
                  <div>
                    {"Aible offers several ways to connect to your data. All data you add is secured in your cloud account " +
                      "and transferred directly to it using pre-signed urls. Aible will evaluate the " +
                      "data in place and generate the data readiness report you can view in Aible."}
                  </div>
                  <div className={styles.sFooter}>
                    <Button onClick={() => updateStep(step - 1)}>{"Previous"}</Button>
                    <Button type="primary" onClick={() => updateStep(step + 1)}>
                      {"Next"}
                    </Button>
                  </div>
                </div>
              ),
              style: {
                maxWidth: "500px",
                minWidth: "500px"
              }
            },
            {
              selector: "#uploadButtons",
              content: () => (
                <div className={styles.tContent}>
                  <div className={styles.tHeader}>{"Upload or Link Data to Continue"}</div>
                  <div>{"No valid dataset detected"}</div>
                  <div style={{ marginTop: "20px" }}>
                    {"Please upload or link your data using the connectors shown. You may continue " +
                      "the walkthrough after uploading a dataset and selecting an outcome."}
                  </div>
                  <div className={styles.sFooter}>
                    <Button onClick={() => updateStep(step - 1)}>{"Previous"}</Button>
                    <Button
                      type="primary"
                      onClick={() => {
                        updateIsOpenSense(false);
                      }}
                    >
                      {"End Walkthrough"}
                    </Button>
                  </div>
                </div>
              ),
              style: {
                maxWidth: "500px",
                minWidth: "500px"
              }
            }
          ]
        : [
            {
              selector: "#mainApp",
              content: ({ goTo, inDOM }) => (
                <div className={styles.tContent}>
                  <div className={styles.aibleLogo}>
                    <img
                      src={AibleLogo}
                      style={{
                        width: "100%",
                        height: "auto"
                      }}
                    />
                  </div>
                  <div className={styles.tHeader + " " + styles.centered}>{"Welcome to Aible Sense!"}</div>
                  <div>
                    {"Aible Sense is the zero upfront effort and low-cost way to evaluate data. " +
                      "Helping you quickly identify what data is ready for analysis and AI creation."}
                  </div>
                  <div className={styles.logoWrapper}>
                    <img
                      src={pathFind}
                      style={{
                        marginTop: "-2px",
                        width: "100%",
                        height: "auto"
                      }}
                    />
                  </div>

                  <div className={styles.tFooter}>
                    <Button
                      type="primary"
                      onClick={() => {
                        updateStep(step + 1);
                        setShowHighlight(true);
                      }}
                    >
                      {"Show Me Around"}
                    </Button>
                  </div>
                </div>
              ),
              style: {
                maxWidth: "500px",
                minWidth: "500px"
              }
            },
            {
              selector: "#senseDataImport",
              content: () => (
                <div className={styles.tContent}>
                  <div className={styles.tHeader}>{"Connecting To Your Data"}</div>
                  <div>
                    {"Aible offers several ways to connect to your data. All data you add is secured in your cloud account " +
                      "and transferred directly to it using pre-signed urls. Aible will evaluate the " +
                      "data in place and generate the data readiness report you can view in Aible."}
                  </div>
                  <div className={styles.sFooter}>
                    <Button onClick={() => updateStep(step - 1)}>{"Previous"}</Button>
                    <Button type="primary" onClick={() => updateStep(step + 1)}>
                      {"Next"}
                    </Button>
                  </div>
                </div>
              ),
              style: {
                maxWidth: "500px",
                minWidth: "500px"
              }
            },
            {
              selector: "#dataset_" + dataset?.id,
              content: () => (
                <div className={styles.tContent}>
                  <div className={styles.tHeader}>{"Your Dataset Overview"}</div>
                  <div>
                    {"Each card in Aible Sense represents an individual dataset you " +
                      "have added to your secure cloud account. Datasets are evaluated for " +
                      "their quality and scored on their readiness to be used for analysis or AI creation."}
                  </div>
                  <div className={styles.sFooter}>
                    <Button onClick={() => updateStep(step - 1)} disabled={isDisableNavigation}>
                      {"Previous"}
                    </Button>
                    <Button
                      type="primary"
                      onClick={() => {
                        handleClickSection("outcomeSection_" + dataset?.id);

                        setTimeout(() => updateStep(step + 1), CLOSE_DELAY);
                      }}
                      disabled={isDisableNavigation}
                    >
                      {"Next"}
                    </Button>
                  </div>
                </div>
              ),
              style: {
                maxWidth: "500px",
                minWidth: "500px"
              }
            },
            {
              selector: "#outcomeSection_" + dataset?.id,
              content: () => (
                <div className={styles.tContent}>
                  <div className={styles.tHeader}>{"The Outcome"}</div>
                  <div>
                    {"Once the dataset is validated, you will see a prompt to select the outcome you would like to evaluate. " +
                      "This is likely a KPI you would chart on the vertical axis or an outcome a model would predict"}
                  </div>
                  <div style={{ marginTop: "20px" }}>
                    {"Tip: you can evaluate different KPIs in the same dataset. Once the first analysis completes, select a " +
                      "new KPI, and Aible will create a second card for that KPI evaluation."}
                  </div>
                  <div className={styles.sFooter}>
                    <Button
                      onClick={() => {
                        setShowHighlight(false);

                        handleClickSection("outcomeSectionClose_" + dataset?.id);

                        setTimeout(() => {
                          updateStep(step - 1);
                          setShowHighlight(true);
                        }, OPEN_DELAY);
                      }}
                      disabled={isDisableNavigation}
                    >
                      {"Previous"}
                    </Button>
                    <Button
                      type="primary"
                      onClick={() => {
                        setShowHighlight(false);

                        handleClickSection("outcomeSectionClose_" + dataset?.id);

                        setTimeout(() => handleClickSection("dataReadinessSection_" + dataset?.id), CLOSE_DELAY);

                        setTimeout(() => {
                          setShowHighlight(true);
                          updateStep(step + 1);
                        }, OPEN_DELAY);
                      }}
                      disabled={isDisableNavigation}
                    >
                      {"Next"}
                    </Button>
                  </div>
                </div>
              ),
              style: {
                maxWidth: "500px",
                minWidth: "500px"
              }
            },
            {
              selector: "#dataReadinessSection_" + dataset?.id,
              content: () => (
                <div className={styles.tContent}>
                  <div className={styles.tHeader}>{"Data Readiness Score"}</div>
                  <div>
                    {"If you are analyzing data, the data readiness indicates whether charts you draw " +
                      "are likely to be statistically sound. For example, a chart may look visually very " +
                      "interesting because the average target is significantly different, but if the " +
                      "standard deviation is significantly greater than the difference in averages, the " +
                      "chart might mislead you."}
                  </div>
                  <div style={{ marginTop: "20px" }}>
                    {"If you are creating a predictive model, data readiness > 0 means the model is better " +
                      "than random chance. Any score above 0.5 " +
                      "is potentially useful, above 2 is likely useful and above 9 may be too good to be true. "}
                  </div>
                  <div style={{ marginTop: "20px" }}>{"The readiness is adjusted for skewed data."}</div>
                  <div className={styles.sFooter}>
                    <Button
                      onClick={() => {
                        setShowHighlight(false);

                        handleClickSection("dataReadinessSectionClose_" + dataset?.id);

                        setTimeout(() => handleClickSection("outcomeSection_" + dataset?.id), CLOSE_DELAY);

                        setTimeout(() => {
                          setShowHighlight(true);
                          updateStep(step - 1);
                        }, OPEN_DELAY);
                      }}
                      disabled={isDisableNavigation}
                    >
                      {"Previous"}
                    </Button>
                    <Button type="primary" onClick={() => updateStep(step + 1)} disabled={isDisableNavigation}>
                      {"Next"}
                    </Button>
                  </div>
                </div>
              ),
              style: {
                maxWidth: "500px",
                minWidth: "500px"
              }
            },
            {
              selector: "#usefulVariablesSection_" + dataset?.id,
              content: () => (
                <div className={styles.tContent}>
                  <div className={styles.tHeader}>{"Useful Variables"}</div>
                  <div>
                    {
                      "These are the fields in your dataset that help explain your selected outcome. Each variable is scored on a scale of 0 - 10."
                    }
                  </div>
                  <div style={{ marginTop: "20px" }}>
                    {
                      "If you are analyzing data, variables with higher quality would be good to visualize on the horizontal axis. Visualizations where a variable with low quality is in the horizontal axis may be statistically less informative and might mislead you. "
                    }
                  </div>
                  <div style={{ marginTop: "20px" }}>
                    {
                      "If you are creating a predictive model, the useful variable analysis checks to see if there is sufficient predictive power in any of your variables. It's okay if your data is messy, there can still be enough to build predictive models. "
                    }
                  </div>
                  <div className={styles.sFooter}>
                    <Button onClick={() => updateStep(step - 1)} disabled={isDisableNavigation}>
                      {"Previous"}
                    </Button>
                    <Button type="primary" onClick={() => updateStep(step + 1)} disabled={isDisableNavigation}>
                      {"Next"}
                    </Button>
                  </div>
                </div>
              ),
              style: {
                maxWidth: "500px",
                minWidth: "500px"
              }
            },
            {
              selector: "#problematicPredictorsSection_" + dataset?.id,
              content: () => (
                <div className={styles.tContent}>
                  <div className={styles.tHeader}>{"Problematic Predictors"}</div>
                  <div>
                    {
                      "If you are analyzing data, you may want to remove these variables. Otherwise, you may draw visualizations that would highlight obvious/trivial relationships between the variables."
                    }
                  </div>
                  <div style={{ marginTop: "20px" }}>
                    {
                      "If you are creating a predictive model, these columns are very good predictors of your outcome. (Maybe a little too good...) Would your model have access to this information when making a prediction? If not, you should remove it; otherwise, you expect your model to time-travel. You should also remove them if they are mathematically related to the outcome (such as calculated fields)."
                    }
                  </div>
                  <div className={styles.sFooter}>
                    <Button onClick={() => updateStep(step - 1)} disabled={isDisableNavigation}>
                      {"Previous"}
                    </Button>
                    <Button
                      type="primary"
                      onClick={() => {
                        setShowHighlight(false);

                        handleClickSection("dataReadinessSectionClose_" + dataset?.id);

                        setTimeout(() => handleClickSection("insightsSection_" + dataset?.id), CLOSE_DELAY);

                        setTimeout(() => {
                          setShowHighlight(true);
                          updateStep(step + 1);
                        }, OPEN_DELAY);
                      }}
                      disabled={isDisableNavigation}
                    >
                      {"Next"}
                    </Button>
                  </div>
                </div>
              ),
              style: {
                maxWidth: "500px",
                minWidth: "500px"
              }
            },
            {
              selector: "#insightsSection_" + dataset?.id,
              content: () => (
                <div className={styles.tContent}>
                  <div className={styles.tHeader}>{"Insights"}</div>
                  <div>
                    {
                      "This visualization highlights the key drivers of the outcome by using the circular Sankey visualization, consisting of chords and arcs. The arcs show the relative importance of a variable and the chords show the importance of the interactions between two variables."
                    }
                  </div>
                  <div style={{ marginTop: "20px" }}>
                    {
                      "Interactions highlight key behaviors that may influence your selected outcome. Exploring these interactions can often offer valuable insights about your business. (Aible Explore license required)"
                    }
                  </div>
                  <div className={styles.sFooter}>
                    <Button
                      onClick={() => {
                        setShowHighlight(false);

                        handleClickSection("insightsSectionClose_" + dataset?.id);

                        setTimeout(() => handleClickSection("dataReadinessSection_" + dataset?.id), CLOSE_DELAY);

                        setTimeout(() => {
                          setShowHighlight(true);
                          updateStep(step - 1);
                        }, OPEN_DELAY);
                      }}
                      disabled={isDisableNavigation}
                    >
                      {"Previous"}
                    </Button>
                    <Button
                      type="primary"
                      onClick={() => {
                        setShowHighlight(false);

                        handleClickSection("insightsSectionClose_" + dataset?.id);

                        setTimeout(
                          () => handleClickSection("dataQualityValidationSection_" + dataset?.id),
                          CLOSE_DELAY
                        );

                        setTimeout(() => {
                          setShowHighlight(true);
                          updateStep(step + 1);
                        }, OPEN_DELAY);
                      }}
                      disabled={isDisableNavigation}
                    >
                      {"Next"}
                    </Button>
                  </div>
                </div>
              ),
              style: {
                maxWidth: "500px",
                minWidth: "500px"
              }
            },
            {
              selector: "#dataQualityValidationSection_" + dataset?.id,
              content: () => (
                <div className={styles.tContent}>
                  <div className={styles.tHeader}>{"Data Quality Validation"}</div>
                  <div>
                    {
                      "Aible conducts 8 data quality checks during the upload process: Outlier Detection, Missing Values, Rare Values, Unique Values, Problematic Predictors, Duplicate Headers, Empty Rows, and Extra Values."
                    }
                  </div>
                  <div style={{ marginTop: "20px" }}>
                    {
                      "Once the dataset passes the validation, you can see an overview of updates that will be applied when this dataset is used for AI creation (Aible Optimize license required)"
                    }
                  </div>
                  <div className={styles.sFooter}>
                    <Button
                      onClick={() => {
                        setShowHighlight(false);

                        handleClickSection("dataQualityValidationSectionClose_" + dataset?.id);

                        setTimeout(() => handleClickSection("insightsSection_" + dataset?.id), CLOSE_DELAY);

                        setTimeout(() => {
                          setShowHighlight(true);
                          updateStep(step - 1);
                        }, OPEN_DELAY);
                      }}
                      disabled={isDisableNavigation}
                    >
                      {"Previous"}
                    </Button>
                    <Button
                      type="primary"
                      onClick={() => {
                        setShowHighlight(false);

                        handleClickSection("dataQualityValidationSectionClose_" + dataset?.id);

                        setTimeout(() => handleClickSection("totalDataEvaluatedSection_" + dataset?.id), CLOSE_DELAY);

                        setTimeout(() => {
                          setShowHighlight(true);
                          updateStep(step + 1);
                        }, OPEN_DELAY);
                      }}
                      disabled={isDisableNavigation}
                    >
                      {"Next"}
                    </Button>
                  </div>
                </div>
              ),
              style: {
                maxWidth: "500px",
                minWidth: "500px"
              }
            },
            {
              selector: "#totalDataEvaluatedSection_" + dataset?.id,
              content: () => (
                <div className={styles.tContent}>
                  <div className={styles.tHeader}>{"Total Data Evaluated"}</div>
                  <div>{"This section highlights the total number of rows and columns in your dataset."}</div>
                  <div style={{ marginTop: "20px" }}>
                    {
                      "If there is a date field present, you will see a chart of how the volume of data changes over time."
                    }
                  </div>
                  <div className={styles.sFooter}>
                    <Button
                      onClick={() => {
                        setShowHighlight(false);

                        handleClickSection("totalDataEvaluatedSectionClose_" + dataset?.id);

                        setTimeout(
                          () => handleClickSection("dataQualityValidationSection_" + dataset?.id),
                          CLOSE_DELAY
                        );

                        setTimeout(() => {
                          setShowHighlight(true);
                          updateStep(step - 1);
                        }, OPEN_DELAY);
                      }}
                      disabled={isDisableNavigation}
                    >
                      {"Previous"}
                    </Button>
                    <Button
                      type="primary"
                      onClick={() => {
                        setShowHighlight(false);

                        handleClickSection("totalDataEvaluatedSectionClose_" + dataset?.id);

                        setTimeout(() => {
                          updateStep(step + 1);
                          setShowHighlight(true);
                        }, CLOSE_DELAY);
                      }}
                      disabled={isDisableNavigation}
                    >
                      {"Next"}
                    </Button>
                  </div>
                </div>
              ),
              style: {
                maxWidth: "500px",
                minWidth: "500px"
              }
            },
            {
              selector: "#mainApp",
              content: () => (
                <div className={styles.tContent}>
                  <div className={styles.tHeader}>{"You Are Ready to Start using Aible Sense! "}</div>
                  <div>
                    <span>{"Please visit our online "}</span>
                    <a href={"https://aible.zendesk.com/hc/en-us"}>{"help portal"}</a>
                    <span>{" or reach out to your customer success partner if you have additional questions. "}</span>
                  </div>
                  <div className={styles.sFooter}>
                    <Button
                      onClick={() => {
                        setShowHighlight(false);

                        handleClickSection("totalDataEvaluatedSection_" + dataset?.id);

                        setTimeout(() => {
                          updateStep(step - 1);
                          setShowHighlight(true);
                        }, CLOSE_DELAY);
                      }}
                      disabled={isDisableNavigation}
                    >
                      {"Previous"}
                    </Button>
                    <Button
                      type="primary"
                      onClick={() => {
                        updateIsOpenSense(false);
                      }}
                    >
                      {"End Walkthrough"}
                    </Button>
                  </div>
                </div>
              ),
              style: {
                maxWidth: "500px",
                minWidth: "500px"
              }
            }
          ];

    return (
      <Tour
        steps={steps}
        isOpen={Boolean(isOpen)}
        onRequestClose={() => updateIsOpenSense(false)}
        goToStep={step}
        startAt={step}
        showNavigation={false}
        showButtons={false}
        closeWithMask={false}
        disableInteraction={false}
        rounded={5}
        accentColor={"#512e77"}
        highlightedMaskClassName={"helpMePlease"}
      />
    );
  }
}
